"use strict";
exports.__esModule = true;
exports.AttributeColorStrategy = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
/**
 * @internal
 */
var AttributeColorStrategy = /** @class */ (function (_super) {
    tslib_1.__extends(AttributeColorStrategy, _super);
    function AttributeColorStrategy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttributeColorStrategy.prototype.createColorAssignment = function (colorPalette, colorMapping, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    viewByAttribute, 
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    stackByAttribute, dv) {
        var attribute = stackByAttribute ? stackByAttribute : viewByAttribute;
        var colorAssignment = base_1.getAtributeColorAssignment(attribute, colorPalette, colorMapping, dv);
        return {
            fullColorAssignment: colorAssignment
        };
    };
    return AttributeColorStrategy;
}(base_1.ColorStrategy));
exports.AttributeColorStrategy = AttributeColorStrategy;
//# sourceMappingURL=attribute.js.map